module.exports = __webpack_public_path__ + "img/icloud.99967678.png";